import React from 'react';
import {useState, useEffect} from "react";
import {useParams, useNavigate, Navigate} from 'react-router-dom';

const Notes = (props) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const navigate = useNavigate();
  
    useEffect(() => {

    }, [navigate]);

    if(error) {
        return <div>Error: {error.message}</div>;
    }
    if(!isLoaded) {
        return <div>Loading...</div>;
    }
    // navigate("/", { replace: true });
    return <div><Navigate to="/events" replace={true} /></div>;
};

export default Notes;